<template>
  <div v-if="isShow" class="radish-right">
    <div class="radish-head">
      <div class="radish-title">快速新建人才</div>
      <div class="radish-btns">
        <div v-show="isSaveShow" class="radish-btn radish-btn-primary" @click="save">保存</div>
        <div class="radish-btn" @click="isShow = false">关闭</div>
      </div>
    </div>
    <div class="radish-body">
      <div v-for="(box, k) in fieldsQuick" :key="k" class="radish-box" :style="{ width: box.boxWidth }">
        <template v-for="(f, fk) in box.fields">
          <formItem
            :key="fk"
            :type="f.type"
            :is-inline="true"
            :is-required="f.isRequired"
            :width="f.width"
            :label="f.label"
            :options="f.options"
            :content="formData[f.label]"
            :handle-data-change="handleItemChange"
          />
          <div v-if="f.label == '手机' && dupData.id" :key="fk + 'd'" class="radish-dup">
            <i class="el-icon-warning">候选人已存在:</i>&nbsp;
            <span class="radish-link" @click="showRadish({ id: dupData.id, name: dupData['姓名'] })">{{
              dupData['姓名']
            }}</span>
            <span>{{ (dupData['公司'] || '-') + ' ' + (dupData['部门'] || '-') }}</span> &nbsp;&nbsp;
          </div>
        </template>
        <formItem
          :type="fieldPro.type"
          :is-inline="true"
          :label="fieldPro.label"
          :options="fieldPro.options"
          :content="pid"
          :handle-data-change="handleProChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      isShow: false,
      fieldsQuick: [
        {
          boxWidth: '100%',
          addButton: false,
          fields: {
            姓名: {
              label: '姓名',
              isRequired: true,
            },
            手机: {
              label: '手机',
              isRequired: true,
            },
            公司: {
              label: '公司',
            },
            部门: {
              label: '部门',
            },
            目前职位: {
              label: '目前职位',
            },
            职能模块: {
              label: '职能模块',
              type: 'multSelect',
              options: [],
            },
            简介: {
              label: '简介',
              type: 'textarea',
            },
          },
        },
      ],
      fieldPro: {
        label: '加入项目',
        type: 'select',
        options: [],
      },
      formData: {},
      dupData: {},
      pid: '',
      isSaveShow: true,
    }
  },
  created: function() {
    Promise.all([this.loadCate()])
  },
  methods: {
    handleItemChange: function(res) {
      const { label, content } = res
      this.formData[label] = content
      if (label == '手机' && content.length > 0) {
        this.duplicate(content)
      }
    },
    handleProChange: function(res) {
      const { label, content } = res
      // if (!this.formData['手机']) {
      //   this.$alert('请填写手机', {showClose: false});
      //   return;
      // }
      this.pid = content
    },
    duplicate: async function(phone) {
      const dup = await app.service('radish').duplicate({ phone: phone })
      if (dup.msg == 'duplicate') {
        this.dupData = dup.data
        this.isSaveShow = false
      } else {
        this.dupData = {}
        this.isSaveShow = true
      }
    },
    save: async function() {
      const dt = JSON.parse(JSON.stringify(this.formData))
      dt['姓名'] = dt['姓名'] ? dt['姓名'].replace(' ', '') : ''
      if (!dt['姓名']) {
        this.$alert('请填写姓名', { showClose: false })
        return
      }
      // if (this.pid && !dt['手机']) {
      //   this.$alert('加入项目请先填写手机', {showClose: false});
      //   return;
      // }
      const result = await app.service('radish').insert(dt)
      if (result.status == 'success') {
        await app.service('misc').insertBussinessAssistTask({
          type: '新建人选',
          data: { radishId: result.data.id, 姓名: dt.姓名 },
        })
        if (this.pid) {
          const pRes = await app.service('radish').intoProject({ pid: this.pid, rid: result.data.id })
          if (pRes.status == 'success') {
            this.$alert('成功添加并加入项目', { showClose: false })
          } else {
            this.$message.error(`intopro error:${pRse.msg}`)
          }
        } else {
          this.$alert('添加成功', { showClose: false })
        }
        // router.push('/radish-detail/'+result.data.id);
      } else {
        this.$message.error(res.msg)
      }
    },
    showRadish: function(params) {
      const { id, name } = params
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.fieldsQuick[0].fields['职能模块'].options = catData.map(item => item['名称'])
      }
    },
    loadPro: async function() {
      if (!app.projects) {
        await app.getProjects()
      }
      const proData = app.projects
      if (proData && proData.length > 0) {
        const opts = {}
        proData.forEach(item => {
          const v = `${item['项目名称']}(${item['客户公司']})`
          opts[item._id] = v
        })
        this.fieldPro.options = opts
      }
    },
    open: function(opts) {
      this.loadPro()
      this.formData = {}
      this.dupData = {}
      this.pid = ''
      this.isSaveShow = true
      const { company, department } = opts
      if (company) {
        this.formData['公司'] = company
      }
      if (department) {
        this.formData['部门'] = department
      }
      this.isShow = true
    },
  },
}
</script>
